import React, {useContext} from 'react';
import { Panel } from '../../components/Panel';
import CompanyOverview from '../../components/CompanyOverview';
import IconComponent from '../../components/IconComponent';
import {AppContext} from "../../context/AppContext";

export function CompanyUserOverview() {
  const {
    getRoutes
  } = useContext(AppContext);

  const ROUTE_CONFIG = getRoutes();

  return (
    <Panel
      header={
        <>
          <IconComponent iconName={ ROUTE_CONFIG.COMPANY_USER_OVERVIEW.icon } />
          { ROUTE_CONFIG.COMPANY_USER_OVERVIEW.title }
        </>
      }
    >
      <CompanyOverview />
    </Panel>
  );
}
